import app from './module/app';
import user from './module/user';
import school from './module/school'
import task from './module/task'
import educationCode from './module/educationCode'
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    app,
    user,
    school,
    task,
    educationCode
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js